import React from "react";

/**
 * Layout component that provides the main application container structure
 * Creates a centered container with configurator styling for the entire application
 * 
 * @param {Object} props - Component props
 * @param {ReactNode} props.children - Child components to render inside the layout container
 */
const Layout = ({ children }) => (
    <>
        <div className="container">
            <div className="configurator">{children}</div>
        </div>
    </>
);

export default Layout;
